import {Inject, injectable} from 'inversify-props';
import {TypedJSON} from 'typedjson';

import {NetworkingStatus} from '@/model/network/Networking';
import {Checkpoint} from '@/model/network/Checkpoint';

import {CheckpointCreateArgs, INetworkNetworkingService} from '@/services/network/INetworkNetworkingService';
import {IApiService} from '@/services/IApi.service';

@injectable()
export class NetworkNetworkingService implements INetworkNetworkingService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/network/networking';

  private serializer = new TypedJSON(Checkpoint);

  public async status(): Promise<NetworkingStatus> {
    return this.apiService.get(`${this.path}/state`);
  }

  public async getHostname(): Promise<string> {
    return this.apiService.get(`${this.path}/hostname`);
  }

  public async setHostname(hostname: string): Promise<void> {
    return this.apiService.post(`${this.path}/hostname`, hostname);
  }

  public async getCheckpoints(): Promise<Checkpoint[]> {
    return (await this.apiService.get(`${this.path}/checkpoints`)).map((c: any) => this.serializer.parse(c));
  }

  public async createCheckpoint(args: CheckpointCreateArgs): Promise<Checkpoint> {
    return this.serializer.parse(await this.apiService.post(`${this.path}/checkpoint`, args))!;
  }

  public async rollbackCheckpoint(id: string): Promise<void> {
    return this.apiService.post(`${this.path}/checkpoint/rollback/${id}`, null);
  }

  public async deleteCheckpoint(id: string): Promise<void> {
    return this.apiService.delete(`${this.path}/checkpoint/${id}`);
  }
}
